import React from 'react';
import appointment from '../../../assets/appointment.jpg';

const MakeAppointment = () => {
    return (
        <div className="hero min-h-screen" style={{ backgroundImage: `url(${appointment})` }}>
            <div className="hero-overlay bg-opacity-60"></div>
            <div className="hero-content text-center text-neutral-content">
                <div className="max-w-md">
                    <h1 className="mb-5 text-5xl font-bold text-white">Make A Appointment</h1>
                    <p className="mb-5">Provident cupiditate voluptatem et in. Quaerat fugiat ut assumenda excepturi exercitationem quasi. In deleniti eaque aut repudiandae et a id nisi.</p>
                    <button className="btn btn-accent text-white">Get Started</button>
                </div>
            </div>
        </div>
    );
};

export default MakeAppointment;